import $ from 'jquery';

const assetExtensions = 'png jpg jpeg gif doc docx xls xlsx pdf ppt pptx'.split(' ');

/**
 * Improves the functionality of links depending on their URL's.
 *
 * @param context
 */
export default function linksEnhancement(context=document.body) {
    const $context = $(context);

    $context.find('a').each(function() {
        const $a = $(this);
        const href = String($a.attr('href'));

        // Checks to make sure there are no `sw-*` properties on the element
        const cleanLink = Array.from(this.attributes).reduce((acc, a) => acc && !/^sw-/.test(a.name), true);

        if (cleanLink) {

            // Animates scroll for anchor links
            // if (href.startsWith('#')) {
            //     $a.attr('sw-scroller', JSON.stringify({ to: href }));
            // }

            // Forces new window clicks for asset files
            const lowerHref = href.toLowerCase();
            for (let ext of assetExtensions) {
                if (lowerHref.endsWith('.' + ext)) {
                    $a.attr('target', '_blank');
                    break;
                }
            }
        }
    });

    // Force no focusing on links just clicked. This ensures no focus outline shows up after clicking.
    $context.find('a, button').on('click', function() {
        $(this).trigger('blur');
    });
}



// WEBPACK FOOTER //
// ./source/scripts/enhancements/links.js